import { asCount } from '../../../../utils/counts';

import { useMarketingNotes } from './use-marketing-notes';

/**
 * How many open action items a venue has, for the venue page banner. It reads
 * the same open-items query the Marketing tab's list uses, so the two share one
 * request and one cache entry and cannot disagree. Undefined until it arrives,
 * and if it fails: a banner that cannot count simply stays away.
 */
export function useOpenTaskCount(venueId: string): number | undefined {
  const { data } = useMarketingNotes(venueId, 'open');
  const first = data?.pages[0];
  // Loaded but the field is absent (an older backend): zero, so the banner stays away.
  return first ? asCount(first.openActionItemCount) : undefined;
}
